import { Controller } from "@hotwired/stimulus";

// Submits the form its element wraps, debounced, as the user types or changes a
// select.
//
// The Profiles search box is the most rage-clicked element on that page — a bare
// text field that did nothing until you pressed Enter and then reloaded the
// whole page, so people clicked it over and over expecting it to respond. This
// makes the control answer immediately. The form still works without JS: it has
// a real submit button and submits on Enter.
export default class extends Controller {
  static targets = ["input"];
  static values = { delay: { type: Number, default: 250 } };

  disconnect() {
    clearTimeout(this.timeout);
  }

  schedule() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.submit(), this.delayValue);
  }

  submitNow() {
    clearTimeout(this.timeout);
    this.submit();
  }

  submit() {
    // requestSubmit fires validation and submit events the way a real click
    // does; older Safari lacks it, so fall back.
    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit();
    } else {
      this.element.submit();
    }
  }
}
